import React from 'react';
import {
    Grid,
    makeStyles,
    Link,
    Chip,
    IconButton,
    Tooltip,
} from '@material-ui/core';
import DisplayDate from '../displayDate/displayDate';
//import { useHistory } from 'react-router-dom';
import '../listItem.component.scss';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import PreviewIcon from '@material-ui/icons/Description';
import { stringConstants } from '../../../constants/stringConstants';
import {capitalize} from '../../../utils/common';

const useStyles = makeStyles((theme) => ({
    icon: {
        color: theme.palette.primary.main
    },
    rounded: {
        backgroundColor: theme.palette.grey[50],
        border: `1px solid #9D9D9D`,
        color: '#9D9D9D',
        width: '30px',
        height: '30px',
        cursor:'pointer'
    },
    listItem: {
        color: '#434343',
        border: '1px solid #ededed',
        alignItems: 'center'
    },
    recordTypeChip: {
        textTransform: 'capitalize',
        padding: '16px 8px', 
        minWidth: '150px',
        borderWidth: '2px'
    }
}));

const ImportListItem = ({entityData, index, listData, setListData, addFormPopupHandler, startImport, previewAgain, downloadFile}) => {
    const classes = useStyles();
    
    return (
        <Grid container className={classes.listItem}>
            <Grid item xs={'auto'} alignItems="top" style={{padding: '0 20px'}}>
                <Grid container spacing={1} style={{padding: '10px 0 20px 0'}}>
                    <Grid item xs={12}>
                        
                    </Grid>
                    <Grid item xs={12}>&nbsp;</Grid>
                </Grid>                
            </Grid>
            <Grid item xs={11}>
                <Grid container spacing={1} style={{padding: '20px 0'}}>
                    <Grid item xs={12} className='textItemTitle'>
                        {(entityData.current_status === 'COMPLETED') ? (<Link 
                            style={{cursor: 'pointer'}}
                            onClick={(e) => {
                                addFormPopupHandler('preview_result', entityData)
                            }}
                        >
                            {entityData.title}
                        </Link>) : entityData.title }
                        
                    </Grid>
                    
                    <Grid item xs={3} alignItems="center" className="secondaryText" style={{display: 'flex'}}>
                        <DisplayDate label="Date" date={entityData.create_date ? entityData.create_date : null} />
                    </Grid>
                    
                    <Grid item xs={2} style={{display: "flex", justifyContent: "flex-start", alignItems: 'center'}}>
                        Type: {entityData.import_type_title}
                    </Grid>

                    <Grid item xs={3} style={{display: "flex", justifyContent: "left", alignItems: 'center'}}>
                        {(entityData.current_status === 'PREVIEW') ? (<>
                            <Chip label={capitalize(entityData.current_status)} variant="outlined" className="listingItemChip" style={{color: '#9D9D9D'}}></Chip> 
                            <Tooltip title="Start Import">
                                    <IconButton
                                        color="primary"
                                        aria-label="Add"
                                        style={{ padding: 0, height: '30px', marginLeft: '10px', marginRight: '10px'}}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            startImport(entityData.PK);
                                        }}
                                    >
                                        <ArrowUpward />
                                    </IconButton>
                                </Tooltip>
                            
                            <Tooltip title="Preview Again">
                                <IconButton
                                color="primary"
                                aria-label="Add"
                                style={{ padding: 0, height: '30px'}}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    previewAgain(entityData.PK);
                                }}
                                >
                                <PreviewIcon />
                                </IconButton>
                            </Tooltip>
                        </>) : (
                            <Chip label={capitalize(entityData.current_status)} variant="outlined" className="listingItemChip" style={{color: '#7D7D7D', border: '2px solid #7D7D7D'}}></Chip>
                        )}                        
                    </Grid>

                    { entityData.processed_file_path &&
                        entityData.processed_file_path != null &&
                        entityData.processed_file_path != 'null' &&
                        entityData.processed_file_path != 'N/A' && (<Grid item xs={1.5} justifyContent='center'><Tooltip
                        
                        title={
                            !entityData.processed_file_path ||
                                entityData.processed_file_path === null ||
                                entityData.processed_file_path === 'null' ||
                                entityData.processed_file_path === 'N/A'
                                ? stringConstants.DownloadNotAvailable
                                : stringConstants.DownloadAvailable
                        }
                    >
                        <Link
                            style={{ cursor: 'pointer', width: '100%', textAlign: 'center', padding: '0 10px'}}
                            variant="contained"
                            onClick={() =>
                                downloadFile(entityData.processed_file_path)
                            }
                            color="primary"
                            disabled={
                                !entityData.processed_file_path ||
                                    entityData.processed_file_path === null ||
                                    entityData.processed_file_path === 'null' ||
                                    entityData.processed_file_path === 'N/A'
                                    ? true
                                    : false
                            }
                        >
                            Records Loaded
                        </Link>
                    </Tooltip></Grid>)}

                    { entityData.exceptions_file_path &&
                        entityData.exceptions_file_path != null &&
                        entityData.exceptions_file_path != 'null' &&
                        entityData.exceptions_file_path != 'N/A' && (<Grid item xs={1.5} justifyContent='center'><Tooltip
                        
                        title={
                            !entityData.exceptions_file_path ||
                                entityData.exceptions_file_path === null ||
                                entityData.exceptions_file_path === 'null' ||
                                entityData.exceptions_file_path === 'N/A'
                                ? stringConstants.DownloadNotAvailable
                                : stringConstants.DownloadAvailable
                        }
                    >
                        <Link
                            style={{ cursor: 'pointer', width: '100%', textAlign: 'center', padding: '0 10px'}}
                            variant="contained"
                            onClick={() =>
                                downloadFile(entityData.exceptions_file_path)
                            }
                            color="primary"
                        >
                            Exception Detail
                        </Link>
                    </Tooltip></Grid>)}

                    {( entityData.termed_file_path &&
                        entityData.termed_file_path != null &&
                        entityData.termed_file_path != 'null' &&
                        entityData.termed_file_path !== 'N/A') && (entityData.import_code != "itilitipa_procedures") && (
                            <Grid item xs={1.5} justifyContent='center'><Tooltip
                            title={
                                !entityData.termed_file_path ||
                                    entityData.termed_file_path === null ||
                                    entityData.termed_file_path === 'null' ||
                                    entityData.termed_file_path === 'N/A'
                                    ? stringConstants.DownloadNotAvailable
                                    : stringConstants.DownloadAvailable
                            }
                        >
                            <Link
                                style={{ cursor: 'pointer', width: '100%', textAlign: 'center' }}
                                variant="contained"
                                onClick={() => downloadFile(entityData.termed_file_path)}
                                color="primary"
                            >
                                Termed Detail
                            </Link>
                        </Tooltip></Grid>
                    )}
                    
                </Grid>
            </Grid>
            
        </Grid>
    )

}

export default ImportListItem;